// PageShell.jsx — wraps every authenticated page with the sidebar + content offset
import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import TopMenuBar from "./TopMenuBar";
import { useSideNavStore, SIDEBAR_WIDE, SIDEBAR_NARROW } from "./store/sideNavStore";

export default function PageShell({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const collapsed = useSideNavStore((state) => state.collapsed);

  const sidebarWidth = isMobile ? 0 : collapsed ? SIDEBAR_NARROW : SIDEBAR_WIDE;

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#0F172A",
        backgroundImage: "url(/freeze_data.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // Pin the freeze image to the viewport so it doesn't rescale when
        // the page's content grows (e.g. expanding a Reports row). Without
        // this, "cover" would re-fit to the now-taller container and
        // produce a visible zoom on expand/collapse.
        backgroundAttachment: "fixed",
      }}
    >
      {/* Sidebar */}
      <TopMenuBar />

      {/* Main content — offset by sidebar width. minWidth: 0 overrides the
          flexbox default (min-width: auto), which otherwise lets this item
          grow to fit its widest descendant (e.g. a wide data table) instead
          of being capped to the space actually available next to the
          sidebar — the whole page would silently grow wider than the
          viewport and every child's own overflowX:auto (meant to scroll
          internally) would never engage, because the overflow had already
          happened one level up. */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          ml: isMobile ? 0 : `${sidebarWidth}px`,
          transition: "margin-left 0.22s cubic-bezier(0.4,0,0.2,1)",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          pt: isMobile ? "56px" : 0, // room for mobile hamburger
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
